import React from 'react'
import formatCurrency from 'App/helpers/formatCurrency'
import get from 'lodash/get'
import PropTypes from 'prop-types'

export default class ComponentName extends React.Component {
  static propTypes = {
    lastTrade: PropTypes.object,
    secondaryCurrency: PropTypes.object
  }
  render() {
    const { lastTrade, secondaryCurrency } = this.props
    return (
      <div className="col-xs-5">
        <b>
          {get(lastTrade, 'price')
            ? secondaryCurrency.symbol +
              formatCurrency(lastTrade.price, secondaryCurrency)
            : '-'}
        </b>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/Price/index.js